// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/sites/v1/service

import type {
  CreateCircuitDeviceRequest,
  CreateCircuitDeviceResponse,
  DeleteCircuitDeviceRequest,
  DeleteCircuitDeviceResponse,
  GetCircuitDeviceRequest,
  GetCircuitDeviceResponse,
  ListCircuitDevicesRequest,
  ListCircuitDevicesResponse,
  UpdateCircuitDeviceRequest,
  UpdateCircuitDeviceResponse,
} from "@proto/gen/sites/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getCircuitDeviceClient } from "./client"

export interface CircuitDeviceServiceState {
  /** State for listCircuitDevices method */
  listCircuitDevices: MethodState<ListCircuitDevicesResponse>
  /** State for createCircuitDevice method */
  createCircuitDevice: MethodState<CreateCircuitDeviceResponse>
  /** State for getCircuitDevice method */
  getCircuitDevice: MethodState<GetCircuitDeviceResponse>
  /** State for updateCircuitDevice method */
  updateCircuitDevice: MethodState<UpdateCircuitDeviceResponse>
  /** State for deleteCircuitDevice method */
  deleteCircuitDevice: MethodState<DeleteCircuitDeviceResponse>
  /** Call listCircuitDevices method */
  listCircuitDevicesAsync: (req: ListCircuitDevicesRequest) => Promise<ListCircuitDevicesResponse>
  /** Call createCircuitDevice method */
  createCircuitDeviceAsync: (
    req: CreateCircuitDeviceRequest
  ) => Promise<CreateCircuitDeviceResponse>
  /** Call getCircuitDevice method */
  getCircuitDeviceAsync: (req: GetCircuitDeviceRequest) => Promise<GetCircuitDeviceResponse>
  /** Call updateCircuitDevice method */
  updateCircuitDeviceAsync: (
    req: UpdateCircuitDeviceRequest
  ) => Promise<UpdateCircuitDeviceResponse>
  /** Call deleteCircuitDevice method */
  deleteCircuitDeviceAsync: (
    req: DeleteCircuitDeviceRequest
  ) => Promise<DeleteCircuitDeviceResponse>
}

/**
 * Zustand store for CircuitDeviceService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useCircuitDeviceServiceStore = create<CircuitDeviceServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          listCircuitDevices: createMethodState<ListCircuitDevicesResponse>(),
          async listCircuitDevicesAsync(req: ListCircuitDevicesRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listCircuitDevices
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCircuitDeviceClient().listCircuitDevices(req)
              set((state) => {
                const slot = state.listCircuitDevices
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listCircuitDevices
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createCircuitDevice: createMethodState<CreateCircuitDeviceResponse>(),
          async createCircuitDeviceAsync(req: CreateCircuitDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createCircuitDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCircuitDeviceClient().createCircuitDevice(req)
              set((state) => {
                const slot = state.createCircuitDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createCircuitDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getCircuitDevice: createMethodState<GetCircuitDeviceResponse>(),
          async getCircuitDeviceAsync(req: GetCircuitDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getCircuitDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCircuitDeviceClient().getCircuitDevice(req)
              set((state) => {
                const slot = state.getCircuitDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getCircuitDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateCircuitDevice: createMethodState<UpdateCircuitDeviceResponse>(),
          async updateCircuitDeviceAsync(req: UpdateCircuitDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateCircuitDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCircuitDeviceClient().updateCircuitDevice(req)
              set((state) => {
                const slot = state.updateCircuitDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateCircuitDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteCircuitDevice: createMethodState<DeleteCircuitDeviceResponse>(),
          async deleteCircuitDeviceAsync(req: DeleteCircuitDeviceRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteCircuitDevice
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCircuitDeviceClient().deleteCircuitDevice(req)
              set((state) => {
                const slot = state.deleteCircuitDevice
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteCircuitDevice
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "circuitDevice-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<CircuitDeviceServiceState> = {}
          {
            const slot = state.listCircuitDevices
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listCircuitDevices = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListCircuitDevicesResponse>
            }
          }
          {
            const slot = state.createCircuitDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createCircuitDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateCircuitDeviceResponse>
            }
          }
          {
            const slot = state.getCircuitDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getCircuitDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetCircuitDeviceResponse>
            }
          }
          {
            const slot = state.updateCircuitDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateCircuitDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateCircuitDeviceResponse>
            }
          }
          {
            const slot = state.deleteCircuitDevice
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteCircuitDevice = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteCircuitDeviceResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as CircuitDeviceServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "CircuitDeviceService" }
  )
)
